// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * API module for merging customer information in the Hardfin system.
 * Provides type-safe customer record updates with Zod validation.
 */
import * as z from 'zod';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { customerSchema } from '@/customer/api/types';

/**
 */
const mergeCustomerResponseSchema = z
  .object({
    data: customerSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, customer: data }));

/**
 */
type MergeCustomerResponse = z.infer<typeof mergeCustomerResponseSchema>;

/**
 */
export interface MergeCustomerParameters {
  removedCustomerId: string;
  name: string;
  billingAddress: string | null;
  comment: string | null;
  externalId: string | null;
  isArchived: boolean;
  billingContact: {
    name: string | null;
    email: string | null;
    phone: string | null;
  };
}

/**

 */
export async function mergeCustomer(
  key: string,
  parameters: MergeCustomerParameters
): Promise<MergeCustomerResponse> {
  const url = `/v1/customer/${key}/merge`;
  const response = await api.post(url, parameters);

  return parseResponse(mergeCustomerResponseSchema, response.data, {
    schemaName: 'MergeCustomer',
    endpoint: url,
  });
}
